var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rate"},[_c('b-form-rating',{attrs:{"value":_vm.currentProductRate},on:{"change":_vm.changeRate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }